/* theme/assets/fm-cart.js — Formula cart drawer controller (spec 2026-10-02 §6.1): Ajax Cart API + Section Rendering API.
   The section's JSON (cart + compare-at map + strings) is the single source; FmCartView renders it. */
(() => {
  // Not `window.FmCart`: the drawer element's id makes that name truthy before this script defines it.
  if (typeof window.FmCart?.add === 'function') return;
  const base = () => (document.body.dataset.root || '/').replace(/\/$/, '');
  const drawer = () => document.getElementById('FmCart');
  const sectionId = () => drawer()?.dataset.sectionId;
  let data = null;
  const readData = (root) => { const el = root?.querySelector('script[data-fm-cart-data]'); return el ? JSON.parse(el.textContent) : null; };
  const icon = (name) => drawer()?.querySelector(`template[data-fm-icon="${name}"]`)?.innerHTML ?? '';
  function paint(next) {
    if (next) data = next;
    const d = drawer();
    if (!d || !data) return;
    d.querySelector('[data-fm-cart-content]').innerHTML = window.FmCartView.render({ ...data, icon });
    const n = data.cart.item_count;
    document.querySelectorAll('[data-fm-cart-count]').forEach((el) => { el.textContent = String(n); el.hidden = n === 0; });
    d.classList.toggle('is-empty', n === 0);
  }
  const fromSections = (sections) => { const html = sections?.[sectionId()]; return html ? readData(new DOMParser().parseFromString(html, 'text/html')) : null; };
  async function post(path, body) {
    const id = sectionId();
    const r = await fetch(`${base()}/${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, ...(id ? { sections: [id], sections_url: location.pathname } : {}) }) });
    const json = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(window.FmCartView.cartErrorMessage(json));
    return json;
  }
  async function refresh() {
    const id = sectionId();
    if (!id) return;
    const json = await (await fetch(`${base()}/?sections=${encodeURIComponent(id)}`)).json();
    paint(fromSections(json));
  }
  function open() { const d = drawer(); if (d) window.Fm.open(d); else location.href = `${base()}/cart`; }
  async function add(items) {
    const json = await post('cart/add.js', { items });
    const next = fromSections(json.sections);
    if (next) paint(next); else await refresh();
    open();
  }
  async function change(key, quantity) {
    const json = await post('cart/change.js', { id: key, quantity });
    const next = fromSections(json.sections);
    if (next) paint(next); else await refresh();
  }
  async function guarded(el, fn) {
    const err = drawer()?.querySelector('[data-fm-cart-error]');
    if (err) err.hidden = true;
    el?.classList.add('is-loading');
    try { await fn(); }
    catch (e) { if (err) { err.textContent = e.message; err.hidden = false; } else console.error(e); }
    finally { el?.classList.remove('is-loading'); }
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-fm-cart-open]') && drawer()) { e.preventDefault(); open(); return; }
    const addBtn = e.target.closest('[data-fm-addon-add]');
    if (addBtn) { e.preventDefault(); guarded(addBtn, () => add([{ id: Number(addBtn.dataset.fmAddonAdd), quantity: 1 }])); return; }
    const line = e.target.closest('[data-fm-line]');
    if (!line) return;
    const step = e.target.closest('[data-fm-qty]');
    const remove = e.target.closest('[data-fm-remove]');
    if (!step && !remove) return;
    e.preventDefault();
    const next = remove ? 0 : Math.max(0, Number(line.dataset.quantity) + Number(step.dataset.fmQty));
    guarded(line, () => change(line.dataset.fmLine, next));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-fm-qty-input]');
    if (!input) return;
    const line = input.closest('[data-fm-line]');
    guarded(line, () => change(line.dataset.fmLine, Math.max(0, Number(input.value) || 0)));
  });
  document.addEventListener('shopify:section:load', (e) => { if (e.target.querySelector?.('#FmCart')) paint(readData(drawer())); });
  window.FmCart = { add, change, open, refresh, paint, replay: (cart, compare) => paint({ ...data, cart, compare: compare || {} }) };
  const init = () => paint(readData(drawer()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
